import * as React from 'react';

import {type InputAndOptionsClassNames} from 'src/components/lib/token-list-input/new-stuff';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {GenesisTZPicker} from 'src/components/lib/tz/index';
import {
  customTimezones,
  excludedTimezones,
  unsupportedTimezones,
} from './constants';
import {BodySmall} from '@spaced-out/ui-design-system/lib/components/Text';
import classify from '@spaced-out/ui-design-system/lib/utils/classify';

import css from './timezone-picker.css';


type Props = {
  value: string | null | undefined;
  onChange: (tz: string) => unknown;
  classNames?: InputAndOptionsClassNames;
};

/**
 * This is a wrapper around GenesisTZPicker which provides updated timezones
 */
export const TimezonePicker = ({value, onChange, classNames}: Props) => {
  const {t} = useLabelTranslation();

  // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
  const isUnSupportedTimezone = unsupportedTimezones.includes(value);
  return (
    <div className={classify(css.timezonePicker, classNames?.container)}>
      <GenesisTZPicker
        value={value}
        onChange={onChange}
        classNames={{
          box: classify({[css.error]: isUnSupportedTimezone}),
          ...classNames,
        }}
        customTimezones={customTimezones}
        excludedTimezones={excludedTimezones}
      />
      {isUnSupportedTimezone && (
        <BodySmall color="danger">
          {`${t(
            'This_location_is_not_supported_Please_choose_another_location_in_the_same_timezone',
            'This location is not supported. Please choose another location in the same timezone',
          )}`}
        </BodySmall>
      )}
    </div>
  );
};

export default TimezonePicker;
